import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=502a1b70&"
import script from "./detailList.vue?vue&type=script&lang=js&"
export * from "./detailList.vue?vue&type=script&lang=js&"
import style0 from "./detailList.vue?vue&type=style&index=0&id=502a1b70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports